import { ReportManager } from "@/views/reports/ReportManager";

export class BlendedReport extends ReportManager {
  public getTransactionHeaders(): Array<string> {
    // Backward compatibility: reports generated before the "Settlement Currency" and
    // "Gross in Settlement Currency" columns were added are stored on AWS with the older (16 column)
    // layout. Pick the header set that matches the stored data so old reports keep downloading
    // without column misalignment.
    if (this.transactionDetails[0]?.length === 16) {
      return ["ID", "Created Date", "Payment Method", "Gross Currency", "Gross", "Chargebee Fee", "Forex Fee",
        "Cross border Fee", "3DS Fee", "Reserve Deduction", "Total Deductions", "Net", "Category", "Payout ID",
        "Dunning", "Parent Transaction"];
    }
    // Intermediate layout (18 columns): "Settlement Currency" + "Gross in Settlement Currency" were added,
    // but "Payout Date" had not been introduced yet. Without this branch these reports fall through to the
    // newest (19 column) header and every column after "Payout ID" shifts by one.
    if (this.transactionDetails[0]?.length === 18) {
      return ["ID", "Created Date", "Payment Method", "Gross Currency", "Gross", "Settlement Currency", "Gross in Settlement Currency", "Chargebee Fee", "Forex Fee", "Cross border Fee", "3DS Fee",
        "Reserve Deduction", "Total Deductions", "Net in Settlement Currency", "Category", "Payout ID", "Dunning", "Parent Transaction"];
    }
    return ["ID", "Created Date", "Payment Method", "Gross Currency", "Gross", "Settlement Currency", "Gross in Settlement Currency", "Chargebee Fee", "Forex Fee", "Cross border Fee", "3DS Fee",
      "Reserve Deduction", "Total Deductions", "Net in Settlement Currency", "Category", "Payout ID", "Payout Date", "Dunning", "Parent Transaction"];
  }
}